/**
 * Rhapsody page media — generated with Higgsfield (kling3_0_turbo video /
 * nano_banana_pro stills) and served from the shared CDN. Poster PNGs are
 * the exact first frame of each clip so the reel never flashes empty.
 */
import { CDN_BASE_URL } from '../constants';

const BASE = CDN_BASE_URL;
const RH_BASE = 'website_videos/';
const url = (path: string) => `${BASE}${encodeURIComponent(path).replace(/%2F/g, '/')}`;
const rh = (filename: string) => url(`${RH_BASE}${filename}`);

export const RH_MEDIA = {
  heroReel: [
    {
      key: 'space',
      video: rh('hero-space.mp4'),
      poster: rh('hero-space.jpg'),
      genre: 'SCI-FI',
      slug: 'THE RED WALK',
      scene: 'SC 01',
      tc: '00:00:12',
    },
    {
      key: 'animated',
      video: rh('hero-animated.mp4'),
      poster: rh('hero-animated.jpg'),
      genre: 'ANIMATION',
      slug: 'CLOUD DRAGON',
      scene: 'SC 14',
      tc: '00:41:08',
    },
    {
      key: 'scenery',
      video: rh('hero-scenery.mp4'),
      poster: rh('hero-scenery.jpg'),
      genre: 'DOCUMENTARY',
      slug: 'VALLEY AT DAWN',
      scene: 'SC 27',
      tc: '01:12:33',
    },
  ],
  problem: {
    enterprise: rh('problem-enterprise.jpg'),
    filmmakers: rh('problem-filmmakers.jpg'),
    creators: rh('problem-creators.jpg'),
  },
  features: {
    featuresplate: rh('features-plate.jpg'),
  },
  oneLiner: {
    portalShot12: rh('portal-shot-12.png'),
    portalShot15: rh('portal-shot-15.png')
  }
} as const;
